import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { MainLayout } from '@/layouts/mainLayout';
import {
  setStoreDispatch,
  setTokenExpiredCallback,
} from '@/services/api/apiClient';
import type { AppDispatch } from '@/store';

import ROUTES from './routes';

export function RouterWithTokenHandling() {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    // Configure dispatch in ApiClient
    setStoreDispatch(action => {
      dispatch(action as { type: string; payload?: unknown });
    });

    // Register callback to redirect to validation when the token expires
    setTokenExpiredCallback(() => {
      // Set flag in sessionStorage so the MFE can detect it
      sessionStorage.setItem('sessionExpired', 'true');
      const event = new CustomEvent('auth-token-expired');
      window.dispatchEvent(event);

      // Navigate to validation
      navigate(ROUTES.HOME.CHILDREN_ROUTES!.VALIDATION.TO, { replace: true });
    });
  }, [navigate, dispatch]);

  // Render the main layout with routes
  return <MainLayout />;
}
